export const NCD_PAYMENT_FLEXIBILITY_SWITCH = 'ncd_payment_flexibility_switch_fly3452_20220901';
